<template>
  <v-container>
    <v-row>
      <v-toolbar flat dense>
        <v-spacer/>
        <v-btn class="mr-2" @click="leaveRTC">Leave</v-btn>
        <v-btn-toggle v-model="btnMicrophone" dense borderless class="mr-2">
          <v-btn icon dense small>
            <v-icon small style="opacity: 0.4">{{ microphoneIcon }}</v-icon>
          </v-btn>
        </v-btn-toggle>
        <v-btn-toggle v-model="btnVideo" dense borderless>
          <v-btn icon dense small>
            <v-icon small style="opacity: 0.4">{{ videoIcon }}</v-icon>
          </v-btn>
        </v-btn-toggle>
      </v-toolbar>
    </v-row>
    <v-row>
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="accent darken-2"
        ></v-progress-linear>
      <v-alert type="error" :value="error.length > 0">
        {{ error }}
      </v-alert>
      <div ref="remotes">
      </div>
      <!-- <RTCTrack v-for="(t, k) in tracks" :key="k" :transceiver="t"></RTCTrack> -->
      <!-- <WebCam ref="webcam"
        class="ml-12"
        :height="250"
        :width="250"
        :selectFirstDevice="true"
        @started="onStart"
        @cameras="onCameras"
        @notsupportd="onError"
        @error="onError"></WebCam> -->
    </v-row>
    <v-row>
      <!-- <v-select v-model="camera" :items="deviceLabels">
      </v-select> -->
    </v-row>
  </v-container>
</template>

<script>
// import { WebCam } from 'vue-web-cam'\
// import RTCTrack from '@/components/RTCTrack.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'rtcVideo',
  props: { sessionId: String, conversationId: String },
  data () {
    return {
      loading: true,
      btnMicrophone: -1,
      btnVideo: -1,
      deviceLabels: [],
      devices: [],
      camera: null,
      peerConnection: null,
      error: '',
      streams: ''
    }
  },
  mounted () {
    this.joinRTC()
    // this.$store.dispatch('hearro/joinRTCSession', { conversationId: this.conversationId, sessionId: this.sessionId })
  },
  // components: { RTCTrack },
  methods: {
    leaveRTC () {
      this.$store.commit('hearro/removeRTCSession')
      if (this.peerConnection) {
        this.peerConnection.getSenders().forEach(sender => {
          sender.track.stop()
        })
        this.peerConnection = null
      }
      this.$emit('leave')
    },
    onCameras (cameras) {
      cameras.forEach(element => {
        this.deviceLabels.push(element.label)
      });
      this.devices = cameras
      console.log('On Cameras Event', cameras);
    },
    onError (error) {
      console.log('webcamerror', error)
    },
    onStart () {
      this.loading = false
    },
    async joinRTC () {
      try {
        this.loading = true
        this.peerConnection = new RTCPeerConnection({
          iceServers: [
            {
              urls: 'turn:127.0.0.1:3478',
              username: 'user',
              credential: 'password'
            },
            {
              urls: 'stun:127.0.0.1:3478',
              username: 'user',
              credential: 'password'
            }
          ]
        })

        this.peerConnection.oniceconnectionstatechange = e => console.log('ice state chagne', e)
        this.peerConnection.ontrack = e => {
          console.log('new track', e)
          var el = document.createElement(e.track.kind)
          el.srcObject = e.streams[0]
          el.autoplay = true
          el.controls = true
          this.$refs.remotes.appendChild(el)
        }
        this.peerConnection.onnegotiationneeded = e => console.log('negotiation needed', e)

        const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true })
        stream.getTracks().forEach(track => this.peerConnection.addTrack(track, stream))
        let sdpOffer = await this.peerConnection.createOffer()
        await this.peerConnection.setLocalDescription(sdpOffer)
        let sdpReply = await this.$store.dispatch('hearro/negotiateRTCSession', { conversationId: this.conversationId, sessionId: this.sessionId, offer: sdpOffer })
        await this.peerConnection.setRemoteDescription(sdpReply)
        await new Promise(resolve => setTimeout(resolve, 2000))
        sdpOffer = await this.peerConnection.createOffer()
        await this.peerConnection.setLocalDescription(sdpOffer)
        sdpReply = await this.$store.dispatch('hearro/negotiateRTCSession', { conversationId: this.conversationId, sessionId: this.sessionId, offer: sdpOffer })
        await this.peerConnection.setRemoteDescription(sdpReply)
      } catch (e) {
        this.error = e.message
      } finally {
        this.loading = false
      }
    }
  },
  computed: {
    microphoneIcon () {
      return this.btnMicrophone === 0 ? 'fa-microphone-slash' : 'fa-microphone'
    },
    videoIcon () {
      return this.btnVideo === 0 ? 'fa-video-slash' : 'fa-video'
    },
    ...mapGetters({ rtcSession: 'hearro/rtcSession' }),
    tracks () {
      const trans = []
      if (this.rtcSession) {
        console.log(this.rtcSession.peerConnection.getRemoteStreams())
        this.rtcSession.peerConnection.getTransceivers().forEach(t => {
          trans.push(t)
        })
      }
      return trans
    }
  }
}
</script>
